module.exports = __webpack_public_path__ + "img/Panels.e7043f89.png";